import * as tslib_1 from "tslib";
import { tap } from 'rxjs/operators';
import { sentry } from 'sentry';
import * as i0 from "@angular/core";
var SentryInterceptor = /** @class */ (function () {
    function SentryInterceptor() {
    }
    SentryInterceptor.prototype.intercept = function (request, next) {
        var queryParams = request.params.toString();
        var body = request.body;
        return next.handle(request).pipe(tap({
            error: function (err) {
                if (isAuthErrorStatus(err.status) ||
                    hasUnauthenticatedErrorCode(err.error)) {
                    return;
                }
                sentry.setContext('HTTP Request', {
                    url: request.url,
                    method: request.method,
                    queryParams: queryParams,
                    body: sanitizeBody(body),
                });
                var errors = (err.error &&
                    err.error.errors &&
                    Array.isArray(err.error.errors)
                    ? err.error.errors.map(function (error) { return error.message; }).join(' // ')
                    : null) ||
                    (err.error && err.error.message) ||
                    'Unknown error';
                sentry.setContext('HTTP Response', {
                    status: err.status,
                    message: err.message,
                    errors: errors
                });
                sentry.captureException(err);
            }
        }));
    };
    SentryInterceptor.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SentryInterceptor_Factory() { return new SentryInterceptor(); }, token: SentryInterceptor, providedIn: "root" });
    return SentryInterceptor;
}());
export { SentryInterceptor };
function isAuthErrorStatus(status) {
    return status === 401;
}
function hasUnauthenticatedErrorCode(body) {
    return body && Array.isArray(body.errors) && body.errors
        .filter(function (error) { return error.extensions; })
        .some(function (error) { return error.extensions.code === 'UNAUTHENTICATED'; });
}
function sanitizeBody(body) {
    if (!body) {
        return body;
    }
    var sensitiveKeys = ['password', 'token', 'authorization', 'secret'];
    function deepSanitize(obj, seen) {
        var e_1, _a;
        if (seen === void 0) { seen = new WeakSet(); }
        if (obj === null || obj === undefined) {
            return obj;
        }
        if (typeof obj !== 'object') {
            return obj;
        }
        if (seen.has(obj)) {
            return obj;
        }
        seen.add(obj);
        if (Array.isArray(obj)) {
            return obj.map(function (item) { return deepSanitize(item, seen); });
        }
        var clone = {};
        try {
            for (var _b = tslib_1.__values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                if (sensitiveKeys.includes(key.toLowerCase())) {
                    clone[key] = '***';
                }
                else {
                    clone[key] = deepSanitize(obj[key], seen);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return clone;
    }
    return deepSanitize(body);
}
